
import axios from 'axios';
import qs from 'qs';
import { Toast } from 'mint-ui';

import { BASE_URL } from '@/config/index';

const NODE_ENV = process.env.NODE_ENV || 'development';

const axiosRequest = (requestParams, configs = {}) => {
  let request;
  const { method, url, params = {}, data = {}, header } = requestParams;
  const defaultConfig = {
    timeout: 10000,
    withCredentials: true,
    responseType: 'json',
    maxContentLength: 2000,
    maxRedirects: 5
  };
  const interceptResultCode = configs.hasOwnProperty('interceptResultCode') ? configs.interceptResultCode : true; // 拦截data里面的code是非200的
  delete configs.interceptResultCode;
  const config = {
    ...defaultConfig,
    ...configs
  };

  const instance = axios.create({
    ...config
  });

  // 配置拦截器
  //  开发debug拦截器
  const devInterceptorSuccess = (response) => {
    if (NODE_ENV === 'development') {
      console.log(`=========== ${response.config.url} ===========`);
      console.log('%c Success %c AxiosHelper 响应成功', 'color:#fff;background:#41B883;border-radius:2px;font-weight:bold', 'color:gray;font-weight:bold');
      console.log('response:', response);
    }
    return response;
  };
  const devInterceptorFail = (error) => {
    if (NODE_ENV === 'development') {
      console.log(`=========== ${error.config.url} ===========`);
      console.log('%c Error %c AxiosHelper 响应错误', 'color:#fff;background:#EB3941;border-radius:2px;font-weight:bold', 'color:red;font-weight:bold');
      console.log(error);
    }
    return Promise.reject(error);
  };
  instance.interceptors.response.use(devInterceptorSuccess, devInterceptorFail);

  //  响应结果处理
  const responseSuccess = (response) => {
    const { data = {} } = response;
    if (response.status === 200 && data.code) {
      if (interceptResultCode && data.code !== 200) {
        Toast(data.message || '请求失败');
        return Promise.reject(data);
      } else {
        return data;
      }
    } else {
      Toast(data.message || '请求失败');
      return Promise.reject(data);
    }
  };
  const responseFail = (error) => {
    // Toast('请求失败！');
    return Promise.reject(error);
  };
  instance.interceptors.response.use(responseSuccess, responseFail);

  // 默认请求头配置
  let headers = header || {
    Accept: 'application/json, */*',
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  headers = {
    ...headers,
    ...header
  };

  const axiosUrl = /^https?:\/\//i.test(url) ? url : `${BASE_URL}${url}`;
  const axiosConfig = { method, url: axiosUrl, params, headers };

  // 发起请求
  if (method !== 'GET') {
    request = instance({
      ...axiosConfig,
      data,
      transformRequest: data => qs.stringify(data)
    });
  } else {
    request = instance({ ...axiosConfig });
  }

  return request;
};

export default axiosRequest;



// WEBPACK FOOTER //
// ./src/utils/axiosHelper.js